export const stepsArray = {
    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardVm, SHVEnergy.Logic",
    "Id": "e5ff427b-f514-4be8-b3b9-7924216a2333",
    "TotalItems":8,
    "CurrentItem": 2,
    "Items": [
        {
            "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconVm, SHVEnergy.Logic",
            "type": 'WizardItemSingleIcon',
            "Id": "edc33f52-fbd9-4f59-8d13-0151c3c4f177",
            "Header": "Question 1",
            "HelpText": "Question 1 - helptext",
            "Buttons": {
                "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemButtonsVm, SHVEnergy.Logic",
                "NextButtonText": "Next",
                "SecondaryButtonText": "SecondaryButtonText"
            },
            "Answer": "5712974b-ff84-4d97-801b-6a90af9e35cf",
            "Options": [
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "5712974b-ff84-4d97-801b-6a90af9e35cf",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/arrow_16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/arrow_32x32.svg"
                    },
                    "Header": "Q1 O1 - Header",
                    "SubHeader": "Q1 O1 - SubHeader"
                },
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "59c43da6-723f-492f-86be-80f4710357fb",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/arrow-no-stem16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/arrow-no-stem32x32.svg"
                    },
                    "Header": "Q1 O2 - Header",
                    "SubHeader": "Q1 O2 - SubHeader"
                },
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "591adfc9-88a4-4a12-966d-a610c2044bce",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/checkmark_16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/checkmark_32x32.svg"
                    },
                    "Header": "Q1 O3 - Header",
                    "SubHeader": "Q1 O3 - SubHeader"
                }
            ],
            "Checkbox": {
                "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardQuestionCheckboxVm, SHVEnergy.Logic",
                "CheckboxText": "CheckboxText",
                "CheckboxPopupText": "CheckboxPopupText",
                "CheckboxValidationError": "CheckboxValidationError",
                "IsCheckboxMandatory": false
            }
        },
        {
            "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconVm, SHVEnergy.Logic",
            "Id": "f8316d86-660c-4762-b83f-8547046e884e",
            "type": 'WizardItemSingleIcon',
            "Header": "Question 1.1",
            "HelpText": "Question 1.1 - helptext",
            "Buttons": {
                "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemButtonsVm, SHVEnergy.Logic",
                "NextButtonText": "Next",
                "SecondaryButtonText": "SecondaryBtnText TODO"
            },
            "Answer": "4f3c7b27-3b12-4cf4-8ad1-946d28bb8ecc",
            "Options": [
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "58823856-669f-44ca-b237-3b382223c66d",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/download_16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/download_32x32.svg"
                    },
                    "Header": "Q11 O1 - Header",
                    "SubHeader": "Q11 O1 - SubHeader"
                },
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "4f3c7b27-3b12-4cf4-8ad1-946d28bb8ecc",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/e-mail_16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/e-mail_32x32.svg"
                    },
                    "Header": "Q11 O2 - Header",
                    "SubHeader": "Q11 O2 - SubHeader"
                },
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "172d2542-8563-4833-a7e4-4bc93c181078",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/house_16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/house_32x32.svg"
                    },
                    "Header": "Q11 O3 - Header",
                    "SubHeader": "Q11 O3 - SubHeader"
                }
            ],
            "Checkbox": null
        },
        {
            "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconVm, SHVEnergy.Logic",
            "Id": "fb3e2962-3b9e-4079-8ef7-ad8cd6f15744",
            "type": 'WizardItemSingleIcon',
            "Header": "Question 1.2",
            "HelpText": "Question 1.2 - helptext",
            "Buttons": {
                "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemButtonsVm, SHVEnergy.Logic",
                "NextButtonText": "Next",
                "SecondaryButtonText": "SecondaryBtnText TODO"
            },
            "Answer": null,
            "Options": [
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "ee03e873-dbdc-4c4e-935f-b09abf05b47d",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/phone_16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/phone_32x32.svg"
                    },
                    "Header": "Q12 O1 - Header",
                    "SubHeader": "Q12 O1 - SubHeader"
                },
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "e8b36dbe-76b2-4e04-8f50-c179a08ae15d",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/search_16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/search_32x32.svg"
                    },
                    "Header": "Q12 O2 - Header",
                    "SubHeader": "Q12 O2 - SubHeader"
                },
                {
                    "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionVm, SHVEnergy.Logic",
                    "Id": "f100ffbd-2d8f-45f6-871b-518aba2b9007",
                    "Icon": {
                        "$type": "SHVEnergy.Logic.ViewModels.Wizard.WizardItemSingleIconOptionIconVm, SHVEnergy.Logic",
                        "SmallIconUrl": "/-/media/shv-energy-global/icons/arrow_16x16.svg",
                        "LargeIconUrl": "/-/media/shv-energy-global/icons/arrow_32x32.svg"
                    },
                    "Header": "Q12 O3 - Header",
                    "SubHeader": "Q12 O3 - SubHeader"
                }
            ],
            "Checkbox": null
        }
    ]
}